// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    onEnter?: () => void;
    /** How much room it takes in the bar. An order number is four characters; a phone is eleven. */
    width?: "sm" | "md";
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * The search box inside the actions bar's filter mode. It holds its value and nothing else — the
 * bar's own apply button is what sends it, so typing never fires a request per keystroke.
 */
export default function FilterSearchInput({ value, onChange, placeholder, onEnter, width = "md" }: Props) {
    return (
        <div className="filter-search" data-width={width}>
            <input
                className="filter-search-field"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => event.key === "Enter" && onEnter?.()}
                placeholder={placeholder}
            />
            {value && (
                <button type="button" className="filter-search-clear" onClick={() => onChange("")} aria-label={placeholder}>
                    <img src="/icons/close-icon.svg" alt="" width={10} height={10} />
                </button>
            )}
        </div>
    );
}
